/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ListResponse } from '../models/ListResponse';
import type { Manufacturer } from '../models/Manufacturer';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ManufacturerService {

    /**
     * Get a list of `Manufacturer`s
     * @returns any A list of `Manufacturers`.
     * @throws ApiError
     */
    public static listManufacturers({
page,
size,
filter,
sort,
searchTerm,
}: {
/**
 * Page number
 */
page?: number,
/**
 * Number of items per page
 */
size?: number,
/**
 * A filter to apply to the results. Multiple filters can be applied by using the same parameter name multiple times. String must be URL encoded. String follows the format field,operator,value(s),required. Filters can be applied to associations by using `[associatedModel*].[attribute]` as field. If values is an array, which is allowed for e.g. the operators "in", "notIn" etc, the delimiter "|" must be used. "required" is allowed, if a deep filter (= filter on an association) is set. In this case, only entities that have an associated entity are returned. *model name should be written as in the API Response, meaning with lowercase first letter and if need be in plural. `required` is optional
 */
filter?: string,
/**
 * Sorts the results by the given field and order. The format is field:order. The order can be asc or desc. Multiple fields can be sorted by using a comma separated list.
 */
sort?: string,
/**
 * Seach Term for full text search. Whether supported and which fields are included depends on the model.
 */
searchTerm?: string,
}): CancelablePromise<ListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/manufacturers',
            query: {
                'page': page,
                'size': size,
                'filter': filter,
                'sort': sort,
                'searchTerm': searchTerm,
            },
        });
    }

    /**
     * Create a new `Manufacturer`
     * @returns Manufacturer A single `Manufacturer`.
     * @throws ApiError
     */
    public static createManufacturer({
requestBody,
}: {
requestBody: Manufacturer,
}): CancelablePromise<Manufacturer> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/manufacturers',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * Get a specific `Manufacturer`
     * @returns Manufacturer A single `Manufacturer`.
     * @throws ApiError
     */
    public static getManufacturer({
id,
}: {
/**
 * ID of the `Manufacturer`
 */
id: string,
}): CancelablePromise<Manufacturer> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/manufacturers/{id}',
            path: {
                'id': id,
            },
        });
    }

    /**
     * Update a specific `Manufacturer`
     * @returns Manufacturer A single `Manufacturer`.
     * @throws ApiError
     */
    public static updateManufacturer({
id,
requestBody,
}: {
/**
 * ID of the `Manufacturer`
 */
id: string,
requestBody: Manufacturer,
}): CancelablePromise<Manufacturer> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/manufacturers/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * Delete a specific `Manufacturer`
     * @returns void 
     * @throws ApiError
     */
    public static deleteManufacturer({
id,
}: {
/**
 * ID of the `Manufacturer`
 */
id: string,
}): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/manufacturers/{id}',
            path: {
                'id': id,
            },
        });
    }

}
